var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3FCEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.902 37.9499C37.3587 40.5115 39.4885 42.6413 42.0501 44.098L43.426 42.1717C43.8834 41.5314 44.7469 41.3336 45.4376 41.7108C47.626 42.9062 50.0444 43.6327 52.5672 43.8324C53.3762 43.8965 54 44.5716 54 45.3832V52.3253C54 53.1228 53.3968 53.7911 52.6034 53.8726C51.7791 53.9574 50.9475 54 50.1111 54C36.7949 54 26 43.2051 26 29.8889C26 29.0524 26.0427 28.2209 26.1274 27.3965C26.2089 26.6032 26.8772 26 27.6748 26H34.6169C35.4284 26 36.1035 26.6238 36.1676 27.4328C36.3673 29.9556 37.0938 32.3741 38.2892 34.5625C38.6664 35.2531 38.4686 36.1166 37.8283 36.574L35.902 37.9499ZM31.9799 36.9281L34.9354 34.817C34.0974 33.008 33.5231 31.0895 33.2291 29.1111H29.1252C29.1158 29.3698 29.1111 29.6291 29.1111 29.8889C29.1111 41.4868 38.5132 50.8889 50.1111 50.8889C50.3709 50.8889 50.6302 50.8842 50.8889 50.8747V46.7709C48.9105 46.4769 46.9921 45.9026 45.183 45.0646L43.0719 48.0201C42.2179 47.6883 41.3932 47.2979 40.6026 46.8539L40.5122 46.8024C37.464 45.0691 34.931 42.536 33.1976 39.4878L33.1461 39.3974C32.7021 38.6068 32.3117 37.7821 31.9799 36.9281Z",
    fill: "#7ED957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0250d30c0448853c0e5499fbf5208b83.svg";
export { ForwardRef as ReactComponent };